import { render, staticRenderFns } from "./AssignPublicationAuthors.vue?vue&type=template&id=72637369&scoped=true"
import script from "./AssignPublicationAuthors.vue?vue&type=script&lang=js"
export * from "./AssignPublicationAuthors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72637369",
  null
  
)

export default component.exports